export const handleChangeDataPagesEditPersonalInfo = (name, value) => ({
    type: 'CHANGE_DATA_PAGE_EDIT_PERSONAL_INFO', name, value
});